import { render } from "./EconomicToken.vue?vue&type=template&id=aab1f44c&scoped=true"
import script from "./EconomicToken.vue?vue&type=script&lang=js"
export * from "./EconomicToken.vue?vue&type=script&lang=js"

import "./EconomicToken.vue?vue&type=style&index=0&id=aab1f44c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab1f44c"]])

export default __exports__